<script setup lang="ts">
import { LogIn } from "@lucide/vue";
import { signInUrl } from "@/api/client";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { t } from "@/copy/strings";

defineProps<{ open: boolean }>();
</script>

<template>
  <AlertDialog :open="open">
    <AlertDialogContent>
      <AlertDialogHeader>
        <AlertDialogTitle>{{ t.auth.expiredTitle }}</AlertDialogTitle>
        <AlertDialogDescription>{{ t.auth.expiredBody }}</AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <Button as="a" :href="signInUrl()"><LogIn /> {{ t.auth.signIn }}</Button>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
</template>
